import type { ThemeDefinition } from 'vuetify'
import { dark, light } from './tokens'

/**
 * Vuetify themes built from the tokens. Components reference these names, never
 * the hex values (SPEC 13.6).
 */

const mabelsLight: ThemeDefinition = {
  dark: false,
  colors: {
    background: light['surface-base'],
    surface: light['surface-raised'],
    'surface-variant': light['surface-sunken'],
    primary: light.primary,
    secondary: light.accent,
    success: light.success,
    warning: light.warning,
    error: light.error,
    info: light.focus,

    'on-background': light['text-primary'],
    'on-surface': light['text-primary'],
    'on-primary': '#FFFFFF',
    // honey needs dark text; white on it fails AA
    'on-secondary': light['text-primary'],

    /*
      Stated rather than inferred, and MT-114 is why.

      Vuetify derives an on-colour for any surface it is not given one for, and
      for `surface-variant` it produced `#EEEEEE` — a near-white meant for the
      dark variant surface Material assumes. Ours is warm paper, so the splash
      tagline rendered at a contrast ratio of **1.08:1** against a required
      4.5. It was, in practice, invisible, and it had been shipping.
    */
    'on-surface-variant': light['text-primary'],
  },
  variables: {
    'border-color': light['border-subtle'],
    'theme-text-secondary': light['text-secondary'],

    /*
      0.7, not Vuetify's 0.6 (SPEC §21.5).

      Field labels and validation messages are drawn at this opacity. At 0.6,
      `#2A2420` over `#FAF7F2` computes to 4.09:1 — under AA's 4.5:1 — so every
      form label and every error message in the product failed, including the
      message telling somebody what they had typed wrong. 0.7 clears it with
      room to spare while keeping the emphasis distinction the scale exists for.
    */
    'medium-emphasis-opacity': 0.7,
  },
}

const mabelsDark: ThemeDefinition = {
  dark: true,
  colors: {
    background: dark['surface-base'],
    surface: dark['surface-raised'],
    'surface-variant': dark['surface-sunken'],
    primary: dark.primary,
    secondary: dark.accent,
    success: dark.success,
    warning: dark.warning,
    error: dark.error,
    info: dark.focus,

    'on-background': dark['text-primary'],
    'on-surface': dark['text-primary'],
    'on-primary': '#2A1610',
    'on-secondary': '#2A1610',
    'on-surface-variant': dark['text-primary'],
  },
  variables: {
    'border-color': dark['border-subtle'],
    'theme-text-secondary': dark['text-secondary'],
    'medium-emphasis-opacity': 0.7,
  },
}

export const themeConfig = {
  defaultTheme: 'mabelsLight',
  themes: { mabelsLight, mabelsDark },
}
